<template>
  <div class="new-product" v-if="daytimeArr.length > 0">
    <div class="container product-box">
      <div class="tit-box">
        <div class="tit">{{ $t('newproducts') }}</div>
        <el-menu :default-active="active" mode="horizontal">
          <el-menu-item
            v-for="(item, index) in daytimeArr"
            :index="String(index)"
            :key="index"
            @click="$router.push('/product?ind=' + index)"
          >
            <span class="date-tit" @mouseenter="tabChange(item, index)">{{ item }}</span>
          </el-menu-item>
        </el-menu>
        <!-- <div class="more">
        更多
        <i class="el-icon-arrow-right"></i>
        </div>-->
      </div>
      <div class="new-product-info">
        <div class="carousel-container" @mouseenter="stopAnimation" @mouseleave="startAnimation" v-if="newProducts.length>0">
          <div class="carousel-wrapper" ref="wrapper">
            <div class="carousel-item" v-for="(it, index) in newProducts" :key="index">
              <div>
                <div class="row" v-for="(sitem, ind) in it" :key="ind" style="margin-bottom:23px">
                  <div style="margin-top: 10px;">
                    <div class="product-img" @click.stop="$router.push({ 'path': '/proDetail', query: { coNu: sitem.co_Nu } })">
                      <img :src="sitem.imgUrl" :alt="sitem.pr_Na" />
                    </div>
                    <div class="product-txt">
                      <div class="msg" style="padding:10px 0 12px">{{ sitem.co_Nu }}</div>
                      <div
                        class="msg size16"
                        style="padding:0 0 12px"
                        @click="$router.push({ 'path': '/proDetail', query: { coNu: sitem.co_Nu } })"
                      >
                       {{ language === 'en' ? sitem.pr_En_Na : language === 'ru' ? sitem.basicThreeLanguage : language === 'zh' ? sitem.pr_Na:sitem.pr_En_Na }}
                      </div>
                      <div class="msg size14" style="padding:0 0 12px">{{ $t('CBM') }}：{{ sitem.bulk_Stere }}（cbm）</div>
                      <div class="msg size14" style="padding:0 0 8px">{{ $t('DK.OuterQTY') }}：{{ sitem.ou_Lo }}（pcs）</div>
                      <div class="price-box">
                        <p class="price" v-if="userInfo.status === 1">{{ userInfo.symbol }}{{ sitem.price }}</p>
                        <div class="send-inquiry" v-else>
                          <div class="inquiry">{{ $t('DK.SendInquiry') }}</div>
                        </div>
                        <div
                          v-if="userInfo.status === 1"
                          class="cart"
                          :class="markCart(sitem.co_Nu) ? 'active' : ''"
                          @click.stop="handleToCart(sitem)"
                        ></div>
                        <div v-if="isDom"></div>
                        <div
                          v-if="userInfo.status !== 1"
                          class="cart"
                          :class="sitem._num_ ? 'active' : ''"
                          @click.stop="onSendInquiry(sitem,it,ind)"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item" v-for="(it, index) in newProducts" :key="`${index}-copy`">
              <div style="margin-top: 10px;">
                <div class="row" v-for="(sitem, ind) in it" :key="ind" style="margin-bottom:23px">
                  <div>
                    <div class="product-img" @click.stop="$router.push({ 'path': '/proDetail', query: { coNu: sitem.co_Nu } })">
                      <img :src="sitem.imgUrl" :alt="sitem.pr_Na" />
                    </div>
                    <div class="product-txt">
                      <div class="msg" style="padding:10px 0 12px">{{ sitem.co_Nu }}</div>
                      <div
                        class="msg size16"
                        style="padding:0 0 12px"
                        @click="$router.push({ 'path': '/proDetail', query: { coNu: sitem.co_Nu } })"
                      >
                        {{ language === 'en' ? sitem.pr_En_Na : language === 'ru' ? sitem.basicThreeLanguage : language === 'zh' ? sitem.pr_Na:sitem.pr_En_Na }}
                      </div>
                      <div class="msg size14" style="padding:0 0 12px">{{ $t('CBM') }}：{{ sitem.bulk_Stere }}（cbm）</div>
                      <div class="msg size14" style="padding:0 0 8px">{{ $t('DK.OuterQTY') }}：{{ sitem.ou_Lo }}（pcs）</div>
                      <div class="price-box">
                        <p class="price" v-if="userInfo.status === 1">{{ userInfo.symbol }}{{ sitem.price }}</p>
                        <div class="send-inquiry" v-else>
                          <div class="inquiry">{{ $t('DK.SendInquiry') }}</div>
                        </div>
                        <div
                          v-if="userInfo.status === 1"
                          class="cart"
                          :class="markCart(sitem.co_Nu) ? 'active' : ''"
                          @click.stop="handleToCart(sitem)"
                        ></div>
                        <div v-if="isDom"></div>
                        <div
                          v-if="userInfo.status !== 1"
                          class="cart"
                          :class="sitem._num_ ? 'active' : ''"
                          @click.stop="onSendInquiry(sitem,it,ind)"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addCartsApi, deletCartsApi } from '@/api/cart'
import { getDateList, queryPage } from '@/api/product'
import { mapState, mapActions, mapGetters } from 'vuex'
import transformMark from '@/utils/water'
export default {
  name: 'newProduct',
  components: {},
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      btnplay: true, //默认播放

      isDom: false,
      active: '0',
      times: '',
      daytimeArr: [],
      newProducts: [],
      queryParam: {
        pageNo: 1,
        pageSize: 20,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        isAnd: false,
        conditionals: [],
        startTime: null
      }
    }
  },
  computed: {
    // 用户信息
    ...mapState('user', ['userInfo']),
    // 语言
    ...mapState('operate', ['language']),
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),

    // 标记购物车图标
    markCart() {
      return coNu => {
        // 购物车列表为空，直接返回标记
        return this.gettingCart.findIndex(item => item.co_Nu === coNu) > -1
      }
    }
  },
  created() {
    this.getDate()
    this.queryData()
    this.startAnimation()
  },

  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart',
      setEnquiry: 'set_enquiry'
    }),
    startAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = 'running'
        }
      })
    },
    handleClick(item) {
      this.$router.push({
        path: 'proDetail',
        query: {
          coNu: item.co_Nu
        }
      })
    },
    stopAnimation() {
      this.$nextTick(() => {
        if (this.$refs.wrapper) {
          this.$refs.wrapper.style.animationPlayState = 'paused'
        }
      })
    },

    getDate() {
      getDateList({ num: 7 }).then(res => {
        this.daytimeArr = res.data
      })
    },

    queryData() {
      queryPage(this.queryParam)
        .then(res => {
          if (res.success) {
            let arr = []
            let arrTow = []
            this.newProducts = res.data.rows.map(item => {
              const ind = this.getEnquiry[0].list.findIndex(
                it => it.co_Nu === item.co_Nu
              )
              if (ind > -1) {
                return { ...item, _num_: true }
              }
              return { ...item, _num_: false }
            })

            this.newProducts.forEach(item => {
              transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(result => {
                item.imgUrl = result
              })
              if (arr.length == 2) {
                arrTow.push(arr)
                arr = []
              }
              if (arr.length != 2) {
                arr.push(item)
              }
            })
            // if (arr.length == 1) {
            //   arrTow.push(arr)
            // }
            this.newProducts = arrTow
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    onSendInquiry(items, arr, ind) {
      arr.forEach(it => {
        if (it.co_Nu === items.co_Nu) {
          it._num_ = !it._num_
          this.setEnquiry(items)
          this.isDom = true
          this.$nextTick(() => {
            this.isDom = false
          })
        }
      })
    },
    tabChange(item, index) {
      this.active = String(index)
      this.queryParam.startTime = item
      this.queryData()
    },
    // 添加到购物车
    handleToCart(item) {
      // 必须登陆后才能添加购物车
      if (this.userInfo === '') {
        this.$message({
          message: this.$t('noLogin'),
          type: 'warning'
        })
        return
      }
      if (this.markCart(item.co_Nu)) {
        deletCartsApi({
          userId: this.userInfo.id,
          coNus: [item.co_Nu]
        }).then(res => {
          if (res.success) {
            this.deleteCart(item.co_Nu)
          }
        })
      } else {
        addCartsApi({
          client_Nu: this.userInfo.client_Nu,
          userId: this.userInfo.id,
          co_Nu: item.co_Nu,
          number: 1
        }).then(res => {
          if (res.success) {
            this.addCart({
              client_Nu: this.userInfo.client_Nu,
              userId: this.userInfo.id,
              co_Nu: item.co_Nu,
              fa_No: item.fa_No,
              imgUrl: item.imgUrl,
              in_En: item.in_En,
              number: 1,
              ou_Lo: item.ou_Lo,
              pr_En_Na: item.pr_En_Na,
              pr_Na: item.pr_Na,
              price: item.price,
              bulk_Stere: item.bulk_Stere
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.new-product-info {
  width: 1200px;
  height: 882px;
  color: #828282;
  overflow: hidden;
  position: relative;

  .carousel-container {
    position: relative;
    width: 1200px;
    height: 882px;
    overflow: hidden;
  }

  .carousel-wrapper {
    display: flex;
    align-items: center;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    white-space: nowrap;
    animation: carousel 20s linear infinite;
  }

  .carousel-item {
    width: 282px;
    margin-right: 23px;
    display: inline-flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
  }

  @keyframes carousel {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(-50%);
    }
  }
}
.row {
  width: 100%;
  height: 408px;
  margin-bottom: 24px;
  & > div {
    height: 100%;
    background-color: #fff;
  }
  .product-img {
    cursor: pointer;
    overflow: hidden;
    height: 222px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 200px;
      transition-duration: 0.5s;

      &:hover {
        transition-duration: 0.5s;
        transform: scale(1.1);
      }
    }
  }

  .product-txt {
    height: 200px;
    padding: 0 5%;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;

    .msg {
      font-size: 16px;
      color: #222222;
      &.look {
        font-size: 20px;
        color: #ff4d4d;
      }

      &.size16 {
        font-size: 16px;
        color: #222222;
        width: 240px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      &.size14 {
        font-size: 14px;
        color: #666666;
      }
    }

    .send-inquiry {
      display: flex;
      align-items: center;
      // padding: 15px 0 10px;

      &:hover {
        color: red;
      }

      .inquiry {
        font-size: 20px;
        color: #ff4d4d;
        // cursor: pointer;
      }

      .num {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        width: 20px;
        height: 20px;
        color: #fff;
        background-color: #ff760e;
        margin: 2px 0 0 5px;
      }
    }
  }
}
// 66666666666
.product-box {
  max-height: 1030px;

  .tit-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // height: 80px;
    // line-height: 80px;

    .tit {
      font-size: 24px;
      font-weight: bold;
      padding: 0 10px 0 0;
      color: #666666;
    }

    .el-menu {
      flex: 1;
      display: flex;
      // justify-content: right;
      margin: 0 20px 0 30px;
      background: none;
    }

    .el-menu.el-menu--horizontal {
      border: none;
    }

    .el-menu--horizontal > .el-menu-item {
      color: black;
      font-size: 16px;
      height: 35px;
      line-height: 35px;
      padding: 0 20px;

      &:hover {
        background-color: #f5f5f5 !important;
      }
    }

    .el-menu--horizontal > .el-menu-item.is-active {
      color: #4a90f1 !important;
      border-bottom: #4a90f1 2px solid;
      background-color: #f5f5f5;
    }

    .date-tit {
      font-weight: bold;
    }
  }
}

.price-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .price {
    // padding: 15px 0 10px;
    font-size: 20px;
    // font-weight: bold;
    color: #ff4d4d;

    span {
      font-size: 14px;
    }
  }

  .cart {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff4d4d;
    cursor: pointer;
    width: 38px;
    height: 38px;
    background: url(data:image/png;base64,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)
      no-repeat 50%;
    background-size: 100% 100%;
  }

  .active {
    border-radius: 50%;
    background: url(data:image/png;base64,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)
      no-repeat 50%;
    background-size: 100% 100%;
  }
}

.new-product {
  width: 100%;
  background-color: #f5f5f5;
  padding: 20px 0;
}
</style>